import React from 'react';
import { SEO } from './components/SEO';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { USPBar } from './components/USPBar';
import { Services } from './components/Services';
import { ClientCases } from './components/ClientCases';
import { Reviews } from './components/Reviews';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Werkproces } from './components/Werkproces';
import { TeamCarousel } from './components/TeamCarousel';
import { BlogSection } from './components/BlogSection';
import { FAQ } from './components/FAQ';
import { ContactForm } from './components/ContactForm';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white text-[#111827] font-sans" data-id="element-0">
      <SEO title="B2B Agency Noord Digital | Data-gedreven groei" description="Noord Digital is hét B2B digital marketing bureau voor data-gedreven groei. Wij helpen bedrijven met webdesign, SEO en online strategie gebaseerd op bewijs, niet op aannames." keywords="b2b digital marketing agency, b2b marketing bureau, online marketing b2b, data gedreven marketing, webdesign b2b, seo b2b, noord digital" canonical="https://noorddigital.nl/" data-id="element-1" />
      <Header data-id="element-2" />
      <Hero data-id="element-3" />
      <USPBar data-id="element-4" />
      <div id="services" data-id="element-5">
        <Services data-id="element-6" />
      </div>
      <div id="client-cases" data-id="element-7">
        <ClientCases data-id="element-8" />
      </div>
      <Reviews data-id="element-9" />
      <GuaranteeSection data-id="element-10" />
      <Werkproces data-id="element-11" />
      <TeamCarousel data-id="element-12" />
      <BlogSection data-id="element-13" />
      <FAQ data-id="element-14" />
      <ContactForm data-id="element-15" />
      <Footer data-id="element-16" />
    </div>;
}